import React from 'react';
import MobileViewport from './MobileViewport';
import './css/MobileNavigation.css';

// Mobile rules stay with renderObjects and do not affect desktop layouts.
export default function MobileOverlayStyles() {
    return <><MobileViewport /><style>{`
        @media (max-width: 767px) {
            .ui.modal.tbp-mobile-profile.light .tbp-profile-body > button i,
            .ui.modal.tbp-mobile-profile.light .tbp-profile-body > div:first-child i,
            .ui.modal.tbp-mobile-profile.light .tbp-profile-control { color: #000 !important; }
            .tbp-credit-stats { display: grid !important; grid-template-columns: repeat(3,minmax(0,1fr));
                gap: 12px; align-items: start !important; width: 100% !important; }
            .tbp-credit-stats .tbp-credit-stat { width: auto !important; min-width: 0;
                margin: 0 !important; font-size: 14px !important; }
            .tbp-credit-stats .tbp-credit-stat-label { width: 100% !important;
                height: 40px !important; min-height: 40px !important; margin: 0 0 6px !important;
                font-size: 13px !important; line-height: 20px !important; white-space: pre-line !important; }

            .tbp-nickname-dialog .tbp-nickname-choice { display: block; width: 100%; border: 0;
                border-radius: 4px; padding: 14px 16px !important; margin: 0 0 12px !important;
                color: white !important; font-weight: 600; }
            .tbp-nickname-dialog button::before, .tbp-nickname-dialog button::after,
            .tbp-nickname-dialog button > i { display: none !important; content: none !important; }

            .tbp-social-post img:not([src=""]) { margin-bottom: 20px !important; }
            .tbp-comment-author { margin-bottom: 12px !important; }
            .tbp-comment-author img { margin-bottom: 0 !important; }
            .tbp-language-dialog .tbp-language-choice { display: block; width: 100%;
                border: 0; border-radius: 4px; margin: 0 0 12px !important;
                padding: 14px 16px !important; color: white !important; font-weight: 600; }
            .tbp-language-dialog button::before, .tbp-language-dialog button::after,
            .tbp-language-dialog button > i { display: none !important; content: none !important; }

            .tbp-credit-stat-label { white-space: pre-line; line-height: 1.4;
                min-height: 2.8em; margin-bottom: 6px; }
            .ui.modal.tbp-mobile-dialog .tbp-profile-body > button.tbp-profile-close {
                background: transparent !important; width: 44px !important; padding: 0 !important;
                display: flex !important; justify-content: center !important; }
            .tbp-social-post img { display: block !important; margin-left: 0 !important;
                margin-right: 0 !important; object-position: left center !important; }
            .tbp-social-feed .tbp-social-actions { clear: both; flex-basis: 100%; }

            .tbp-credit-stat-label { white-space: pre-line; line-height: 1.4;
                min-height: 2.8em; margin-bottom: 6px; }
            .ui.modal.tbp-mobile-dialog .tbp-profile-body > button.tbp-profile-close {
                background: transparent !important; width: 44px !important; padding: 0 !important;
                display: flex !important; justify-content: center !important; }
            .tbp-social-post img { display: block !important; margin-left: 0 !important;
                margin-right: 0 !important; object-position: left center !important; }
            .tbp-social-feed .tbp-social-actions { clear: both; flex-basis: 100%; }

            .tbp-profile-summary > p { text-align: left !important; justify-self: stretch; }
            .tbp-social-feed .tbp-social-actions { justify-content: flex-end !important;
                width: 100% !important; flex-direction: row !important; margin: 8px 0 !important; }
            .tbp-social-post > div { text-align: left; }
            .tbp-social-post img:not([src=""]) { margin-bottom: 12px; }
            .tbp-comment-author img { margin-bottom: 0 !important; }
            .tbp-profile-body > .tbp-profile-close { width: 44px !important;
                height: 44px !important; min-height: 44px !important; padding: 0 !important;
                margin: 0 0 16px !important; background: transparent !important;
                display: inline-flex !important; align-items: center; justify-content: center; }
            .tbp-profile-close i { color: inherit !important; }
            .ui.modal.tbp-borrow-actions { padding: 20px !important; border-radius: 10px !important; }
            .tbp-borrow-actions .header { padding: 0 0 18px !important;
                border-bottom: 1px solid rgba(128,128,128,.22) !important; margin-bottom: 18px !important; }
            .tbp-borrow-actions .content { padding: 0 !important; }
            .tbp-borrow-actions .tbp-borrow-tab { border-radius: 6px !important;
                padding: 12px 6px !important; margin: 0 !important; }
            .tbp-borrow-actions .tbp-amount-entry { border-radius: 8px;
                padding: 16px; margin-bottom: 18px; }
            .tbp-borrow-actions .tbp-borrow-submit { border-radius: 6px !important;
                background: rgba(128,128,128,.22) !important; border: 1px solid rgba(128,128,128,.22) !important;
                min-height: 48px !important; margin: 0 0 10px !important; }
            .tbp-borrow-actions .tbp-borrow-cancel { border-radius: 6px !important;
                border: 1px solid rgba(128,128,128,.25) !important; min-height: 44px !important; }
            .tbp-borrow-actions .tbp-borrow-submit p, .tbp-borrow-actions .tbp-borrow-cancel p,
            .tbp-borrow-actions .tbp-borrow-tab p { margin: 0 !important; }

            .ui.modal.tbp-mobile-dialog { background: var(--dialog-bg) !important; }
            .ui.modal.tbp-mobile-profile.dark, .ui.modal.tbp-mobile-navigation.dark {
                --dialog-bg: #282c34;
            }
            .tbp-mobile-dialog .ui.header, .tbp-mobile-dialog p,
            .tbp-mobile-dialog .description { background: transparent !important; }
            .tbp-menu-header { display: flex !important; align-items: center; gap: 12px !important; }
            .tbp-menu-brand { flex: 1 !important; min-width: 0; width: auto !important; }
            .tbp-menu-brand p { width: auto !important; min-width: 0; white-space: normal;
                word-break: normal !important; overflow-wrap: normal !important; margin: 0 !important; }
            .tbp-menu-header > button { flex: 0 0 44px !important; width: 44px !important; }
            .tbp-menu-brand img { width: 28px !important; height: 28px !important; flex: 0 0 28px; }
            .tbp-mobile-navigation .item button p { display: flex !important; gap: 12px !important; align-items: center; }
            .tbp-mobile-navigation .item button i { flex: 0 0 22px; width: 22px !important; margin: 0 !important; }
            .tbp-profile-body { color: var(--dialog-text); }
            .tbp-profile-control { width: 44px !important; height: 44px !important; flex: 0 0 44px; }
            .tbp-profile-summary { display: grid; grid-template-columns: 56px minmax(0,1fr);
                gap: 12px; align-items: center; margin: 0 0 24px; }
            .tbp-profile-summary > img { width: 56px; height: 56px; object-fit: cover; border-radius: 50%; }
            .tbp-profile-summary strong { display: block; font-size: 17px; line-height: 1.4; }
            .tbp-profile-summary > p { grid-column: 1 / -1; margin: 0; font-size: 14px; }
            .tbp-social-feed { width: 100%; }
            .tbp-social-post { width: 100%; }
            .tbp-social-actions { display: flex !important; gap: 8px; align-items: center; }
            .tbp-social-feed .tbp-social-action { width: auto !important; min-width: 44px;
                height: 44px !important; background: transparent !important; padding: 8px !important; }
            .tbp-social-action p, .tbp-social-action div { width: auto !important; margin: 0 !important; }
            .tbp-comment-author { display: flex !important; align-items: center; gap: 10px; }
            .tbp-comment-author > div:first-child { width: 32px !important; height: 32px !important; flex: 0 0 32px; }
            .tbp-amount-entry { display: flex; align-items: center; gap: 12px; padding: 12px 16px;
                margin: 0 0 20px; background: rgba(128,128,128,.12); border: 1px solid rgba(128,128,128,.3); }
            .ui.modal.tbp-mobile-dialog .tbp-amount-entry input { flex: 1; min-width: 0; width: 100% !important;
                margin: 0 !important; padding: 0 !important; border: 0 !important; background: transparent !important;
                min-height: 48px !important; height: 48px !important; font-size: 28px !important; }
            .tbp-amount-entry > span { flex: 0 0 auto; font-size: 16px; font-weight: 600; }

            .ui.modal.tbp-overlay, .ui.modal.tbp-mobile-dialog {
                --dialog-text: #171717;
                --dialog-bg: #eaeaea;
                width: calc(100% - 24px) !important;
                max-width: 520px !important;
                height: auto !important;
                min-height: 0 !important;
                max-height: calc(100dvh - 32px) !important;
                margin: 16px auto !important;
                overflow-x: hidden !important;
                overflow-y: auto !important;
                box-sizing: border-box;
            }
            .ui.modal.tbp-mobile-dialog.dark {
                --dialog-text: #fff;
                --dialog-bg: #3e4349;
            }
            .tbp-mobile-dialog * { box-sizing: border-box; }
            .ui.modal.tbp-mobile-dialog > .header,
            .ui.modal.tbp-mobile-dialog > .content,
            .tbp-mobile-dialog .description {
                position: static !important;
                height: auto !important;
                min-height: 0 !important;
                width: 100% !important;
                color: var(--dialog-text) !important;
                background: transparent !important;
                overflow: visible !important;
            }
            .tbp-mobile-dialog .header p { margin: 0 !important; }
            .tbp-mobile-dialog p, .tbp-mobile-dialog .header {
                overflow-wrap: anywhere;
                line-height: 1.5 !important;
            }
            .tbp-mobile-dialog button, .tbp-mobile-dialog .ui.button {
                max-width: 100%;
                min-height: 44px;
                font-size: 16px !important;
                line-height: 1.4 !important;
            }
            .tbp-mobile-dialog input, .tbp-mobile-dialog textarea {
                max-width: 100%;
                font-size: 16px !important;
            }
            .tbp-mobile-dialog .actions {
                display: flex !important;
                flex-wrap: wrap;
                gap: 12px;
                padding: 20px !important;
            }
            .tbp-mobile-dialog .actions > button { flex: 1; margin: 0 !important; }
            .tbp-mobile-profile button i { width: 20px; height: 20px; margin: 0 !important; }
            .tbp-mobile-profile .scrollContainer,
            .tbp-mobile-profile .scrollNoScrollBar { overflow: visible !important; }
        }
    `}</style></>;
}
